import React from "react";

const AnnouncementsPage = () => {
    return (
        <div className="wrapper">
            <div className="page">

            </div>
        </div>
    )
}

export default AnnouncementsPage;